<template>
    <img class="topImgSty" :src="pictureLang[$i18n.locale]">
</template>
<script>
export default {
    data() {
        return {
            pictureLang: {
                en: "https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/1headen.jpg",
                ja: "https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/1headja.jpg",
                "zh-cn": "https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/1headch.jpg",
            }
        }
    },
}
</script>
<style></style>
 


// WEBPACK FOOTER //
// src/components/topPicTeaching.vue